import Button from 'components/atoms/Button';
import PdfIcon from 'components/atoms/Pdf';
import classNames from 'classnames';
import { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ToggleActive from 'components/atoms/ToggleActive';
import CardClicklabe from './CardClickable';
import CardHeader from './CardHeader';
import CardDescription from './CardDescription';
import CardTags from './CardTags';
import CardClassification from './CardClassification';
import CardRegisterDate from './CardRegisterDate';
import CardNumberDownloads from './CardNumberDownloads';
import CardDocumentType from './CardDocumentType';
import { GlobalContext } from 'Context/GlobalContext/AppContext';
import tipoDocEnum from 'pools/tipoDocEnum';
import './styles.scss';



const Card = ({ handleDelete, handleDownload, document, classificacao, setToRefresh, isExpanded }) => {
  const { setHistoryModal, setTreeModal, user } = useContext(GlobalContext);
  const [isVisible, setIsVisible] = useState(false);
  const [expand, setExpand] = useState(isExpanded);
  const norma = 1;

  function handleExpand() {
    setExpand((state) => !state);
    }

    function handleCopy(url) {
        navigator.clipboard.writeText(`${window.location.href}${url}`);
    }

  //Send document to History Modal and show it
  function handleHistory() {
    setHistoryModal({ isVisible: true, norma: document });
  }

  //Send document to History Modal and show it
  function handleTreeView() {
    setTreeModal({ isVisible: true, documents: document });
  }

  //Initial animation
  useEffect(() => {
    setTimeout(() => {
      setIsVisible(true);
    }, 150);
  }, [setIsVisible]);

  const cardClass = classNames({
    card: true,
    'card--isVisible': isVisible,
    'card--expanded': expand,
    'card--admin': user.isAuthenticated,
  });

 

  return (
    <div className={cardClass}>
      <PdfIcon small={!expand} thumbnail={document.URLThumbnail} id={document.ID} tipoDoc={document.TipoDoc} title={document.Titulo} />
      <CardHeader code={document.NRDocumento} title={document.Titulo} version={document.Versao} onClick={handleExpand} />
      <CardClicklabe onClick={handleExpand}>
        <CardDescription description={document.Descricao} expand={expand} />
      </CardClicklabe>
      {document.TipoDoc === norma && <CardClassification classification={classificacao} expand={expand} />}
          <CardRegisterDate date={document?.DTCadastro} expand={expand} />
         
          
      <Button visual="download" onClick={() => handleDownload(document)}>
        Baixar
      </Button>

      {user.isAuthenticated && (
        <Button tag={Link} visual="edit" to={`${tipoDocEnum[document.TipoDoc]}/Editar/${document?.ID}`}>
          Editar
        </Button>
      )}
      <Button visual="history" onClick={handleHistory}>
        Histórico
          </Button>

          
          {user.isAuthenticated && expand && (

              <>
                  <Button visual="copy" onClick={() => handleCopy(`${tipoDocEnum[document.TipoDoc]}/Detalhe/${document.ID}`)}>
                      Copiar link
                  </Button>
          <Button visual="delete" onClick={() => handleDelete(document)}>
            Apagar
          </Button>

          <ToggleActive document={document} setToRefresh={setToRefresh} />
        </>
      )}
      {expand && (
        <>
          <CardNumberDownloads nDownloads={document?.NDownload} expand />
          <CardTags tags={document?.Tag} />
          <Link className="card__detail" to={`${tipoDocEnum[document.TipoDoc]}/Detalhe/${document.ID}`}>
            + Detalhes 
          </Link>
          <Button visual="related" onClick={handleTreeView} disabled={document.Documentos.length <= 0 && document.Links.length <= 0 ? true : false}>
            Documentos Relacionados
          </Button>
        </>
      )}
      <CardDocumentType docType={document.TipoDoc} expand={expand} />
    </div>
  );
};

export default Card;
